import React, { Component } from 'react';
import './index.scss';
import Button from '../Button';
import PostCard from '../PostCard';
import MediaQuery from 'react-responsive';

class PostList extends Component {
  componentDidMount() {
    this.props.loadData();
  }

  _showText = (content , showNum) =>{
    if( content.length > showNum){
        var textLimit = content.substring(0,showNum).concat('......');

    }else{
        var textLimit = content.concat('......');
    }
    return textLimit;
  }

  render() {
    const{ postList } = this.props;

    return (
      <div className="section -post">
        <div className="content-section -post">
          <div className="container -post -horizon-padding ">
            <div className=" content">
              <div className="">
                <MediaQuery query='(max-width: 599px)'>
                {
                  postList &&
                  postList.data &&
                  postList.data.length > 0 &&
                  postList.data.map((post,i) =>{
                    return(
                      <div className="post-card-wrapper -posts" key={i}>
                      <PostCard uuid={post.uuid} hashId={`#${post.category}`} title={post.title} article={this._showText(post.content,70)}></PostCard>
                      </div>
                    )
                  })
                }
              </MediaQuery>
            <MediaQuery query='(min-width: 600px)'>
            {
              postList &&
              postList.data &&
              postList.data.length > 0 &&
              postList.data.map((post,i) =>{
                return(
                  <div className="post-card-wrapper -posts" key={i}>
                  <PostCard uuid={post.uuid} hashId={`#${post.category}`} title={post.title} article={this._showText(post.content,127)}></PostCard>
                  </div>
                )
              })
            }
          </MediaQuery>
              </div>
            </div>
        </div>
      </div>
      </div>

    );
  }
}

export default PostList;



// WEBPACK FOOTER //
// ./src/components/PostList/pure.js